var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'backbone'], function($, Backbone) {
  /*
  # It'll update provided model after form elements (input/select) changes
  # Requires matched IDs for the form element (model property == DOM element id), for example:
  #
  # clientModel: {"email": "test@example.com"}
  # <input type="text" id="email" name="email" />
  #
  # Can be applied to some form inside main view
  */

  var ModelUpdateView;
  return ModelUpdateView = (function(_super) {

    __extends(ModelUpdateView, _super);

    function ModelUpdateView() {
      ModelUpdateView.__super__.constructor.apply(this, arguments);
    }

    ModelUpdateView.prototype.events = {
      'change input': 'finishEditing',
      'keyup input': 'finishEditing',
      'change select': 'finishEditing'
    };

    ModelUpdateView.prototype.finishEditing = function(e) {
      var element, key, value;
      element = $(e.currentTarget);
      key = element.attr('id');
      value = e.currentTarget.type === 'checkbox' ? $(element).is(':checked') : $(element).val();
      return this.model.set(key, value);
    };

    return ModelUpdateView;

  })(Backbone.View);
});
